import { atomWithStorage } from "jotai/utils";
import { MenuState, User } from "@/utils/store/types";
import { atom } from "jotai";
import { TestmailAppEmail } from "@/server/services/TestmailappService";
import { WebmailFilter } from "@/utils/types/custom";
import { ActionResult } from "@/server/actions/ActionResult";

export const userAtom = atomWithStorage<User>("user", {
    id: "",
    email: "",
    firstname: "",
    lastname: "",
});

export const menuAtom = atomWithStorage<MenuState>("menu", {
    currentItem: undefined,
});

export const helpUrlAtom = atom<string>("");
export const selectedInboxAtom = atom<string>("");
export const selectedWebmailFilterAtom = atom<WebmailFilter>("all");
export const emailAtom = atom<TestmailAppEmail | null>(null);

export const writeNoteDialogOpenAtom = atom<boolean>(false);
export const cancelReasonDialogOpenAtom = atom<boolean>(false);
export const appointmentDialogAtom = atom<boolean>(false);
export const viewingDialogAtom = atom<boolean>(false);
export const nullifyBookingAtom = atom<boolean>(false);
export const extendBookingAtom = atom<boolean>(false);
export const billedMarkedAtom = atom<boolean>(false);
export const changeRentDialogOpenAtom = atom<boolean>(false);
export const allNoteDialogOpenAtom = atom<boolean>(false);
export const deleteDialogOpenAtom = atom<boolean>(false);

export type DeleteDialogState = {
    open: boolean;
    title: string;
    id: string;
    redirectUrl?: string;
};

export type YesNoDialogState = {
    open: boolean;
    title: string;
    description: string;
    id: string;
    redirectUrl?: string;
    func?: (...params: any) => Promise<ActionResult>;
};

export type OneUpdateableFieldState = {
    open: boolean;
    id: string;
    content: string;
    redirectUrl?: string;
};

export type DocumentViewDialogState = {
    open: boolean;
    data: Uint8Array | null;
    type: "pdf" | "jpg" | "png" | null;
    title: string | null;
};

export const contractChangelogDialogStateAtom = atom<OneUpdateableFieldState>({
    open: false,
    id: "",
    content: "",
});

export const deleteNoteDialogStateAtom = atom<DeleteDialogState>({
    open: false,
    title: "Notiz",
    id: "",
});

export const deleteBookingDialogStateAtom = atom<DeleteDialogState>({
    open: false,
    title: "Buchung",
    id: "",
});

export const unarchiveBookingDialogStateAtom = atom<DeleteDialogState>({
    open: false,
    title: "Buchung",
    id: "",
});

export const deleteExtensionDialogStateAtom = atom<DeleteDialogState>({
    open: false,
    title: "Verlängerung",
    id: "",
});

export const deleteContactDialogStateAtom = atom<DeleteDialogState>({
    open: false,
    title: "Kontakt",
    id: "",
});

export const deleteTenantDialogStateAtom = atom<DeleteDialogState>({
    open: false,
    title: "Mieter",
    id: "",
});

export const deleteInhabitantDialogStateAtom = atom<DeleteDialogState>({
    open: false,
    title: "Bewohner",
    id: "",
});

export const deleteLandlordDialogStateAtom = atom<DeleteDialogState>({
    open: false,
    title: "Vermieter",
    id: "",
});

export const deleteRealEstateDialogStateAtom = atom<DeleteDialogState>({
    open: false,
    title: "Objekt",
    id: "",
});

export const deleteDocumentDialogStateAtom = atom<DeleteDialogState>({
    open: false,
    title: "Dokument",
    id: "",
});

export const documentViewDialogStateAtom = atom<DocumentViewDialogState>({
    open: false,
    data: null,
    type: null,
    title: null,
});

export const yesNoDialogStateAtom = atom<YesNoDialogState>({
    open: false,
    title: "Dokument",
    description: "",
    id: "",
    func: undefined,
});

export const generalDialogStateAtom = atom<DeleteDialogState>({
    open: false,
    title: "Change Me!",
    id: "",
});

export const deleteTenantDialogOpenAtom = atom<boolean>(false);

export const deleteBookingDialogOpenAtom = atom<boolean>(false);
export const deleteInvoiceDialogOpenAtom = atom<boolean>(false);
export const deleteInhabtitantDialogOpenAtom = atom<boolean>(false);
export const deleteContactDialogOpenAtom = atom<boolean>(false);

export const terminateContractDialogOpenAtom = atom<boolean>(false);
export const reviewEmailDialogOpenAtom = atom<boolean>(false);
